// extracted by mini-css-extract-plugin
export default {"partners":"AboutUs_partners__ISOCH","subtitle":"AboutUs_subtitle__7aZvI","content":"AboutUs_content__C9uFE","doubleSections":"AboutUs_doubleSections__-aPYU"};